module.exports = __webpack_public_path__ + "img/pay-out.dc8aaf0e.jpeg";